<template>
  <div>
    <div>
      <!-- NF-e -->
      <b-form-group :label="$t('tracking.cargo.path.nfe')" label-for="nfe">
        <b-form-input
          id="nfe"
          type="text"
          :placeholder="$t('tracking.cargo.path.nfe')"
          v-model="model.nfeNumber"
          :readonly="readonly"
        />
      </b-form-group>
      <!-- CT-e -->
      <b-form-group :label="$t('tracking.cargo.path.cte')" label-for="cte">
        <b-form-input
          id="cte"
          type="text"
          :placeholder="$t('tracking.cargo.path.cte')"
          v-model="model.cteNumber"
          :readonly="readonly"
        />
      </b-form-group>
      <!-- ManifestNumber -->
      <b-form-group :label="$t('tracking.cargo.path.manifest')" label-for="ManifestNumber">
        <b-form-input
          id="ManifestNumber"
          type="text"
          :placeholder="$t('tracking.cargo.path.manifest')"
          v-model="model.manifestNumber"
        />
      </b-form-group>
      <!-- Ciot -->
      <b-form-group :label="$t('tracking.cargo.path.ciot')" label-for="ciot">
        <b-form-input
          id="ciot"
          type="text"
          :placeholder="$t('tracking.cargo.path.ciot')"
          v-model="model.ciotNumber"
          :readonly="readonly"
        />
      </b-form-group>
      <!-- Freight Contract -->
      <b-form-group
        :label="$t('tracking.cargo.path.freightContract')"
        label-for="freightContract"
      >
        <b-form-input
          id="freightContract"
          type="text"
          :placeholder="$t('tracking.cargo.path.freightContract')"
          v-model="model.freightContract"
          :readonly="readonly"
        />
      </b-form-group>
    </div>
    <!-- {{ model }} -->
  </div>
</template>
<script>
import BaseRowDetail from "../../../base/BaseRowDetail.vue";
export default {
  name: "CargoStatusCrudWaitingDocumentPath",
  components: {
    BaseRowDetail,
  },
  props: {
    model: Object,
    modelstate: Object,
    readonly: Boolean,
  },
  data: function () {
    return {};
  },
  created() {},
  computed: {},
  methods: {},
};
</script>
